/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { Observable, of } from 'rxjs'
import { PageTitleService } from './page-title.service'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'myprofile-page-title',
  templateUrl: './page-title.component.html',
  imports: [PorscheDesignSystemModule, AsyncPipe],
  // Angular 22 changed the implicit default to OnPush (see angular/angular#67687). This component was never migrated
  // to OnPush semantics, so Eager restores the pre-v22 behaviour it relies on.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PageTitleComponent implements OnInit {
  private pageTitleService = inject(PageTitleService)
  private translateService = inject(TranslateService)

  @Input() backLink = false
  @Input() backLinkContent!: string
  @Input() backLinkHref!: string
  @Input() pageTitle!: string

  coreUrl!: string
  country!: string
  locale!: string

  ngOnInit(): void {
    this.coreUrl = this.pageTitleService.getPageUrl()
  }

  get href(): string {
    return this.backLinkHref ? this.backLinkHref : this.coreUrl
  }

  get linkValue(): Observable<string> {
    return this.backLinkContent ? of(this.backLinkContent) : this.translateService.get('ANGULAR_COMMON.PAGE_TITLE.LINK_CONTENT')
  }

  get title(): string {
    return this.pageTitle ? this.pageTitle : '[pageTitle missing]'
  }
}
